import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../Input";
import { useForm } from "react-hook-form";
import { useHabUnits } from "../../Providers/HabUnit";
import { useServices } from "../../Providers/Services";
import * as yup from "yup";
import { IHU, IServiceHU } from "../../Interfaces";
import Button from "../Button";
import { Container } from "./styles";
interface IServiceProps {
  HU: IHU;
  servicesState?: IServiceHU[];
  updateServState: (prods: IServiceHU[]) => void;
  closeModal: () => void;
}

const AddService = ({
  HU,
  servicesState,
  updateServState,
  closeModal,
}: IServiceProps) => {
  interface IFormData {
    id: number;
    quantity: number;
  }

  const { services } = useServices();
  const { addService } = useHabUnits();

  const schema = yup.object().shape({
    id: yup
      .string()
      .required("Campo obrigatório")
      .matches(/^\d+$/, "Apenas números"),
    quantity: yup
      .string()
      .required("Campo obrigatório")
      .matches(/^\d+$/, "Apenas números"),
  });

  const onSubmit = (data: IFormData) => {
    const selectedService = services.find((el) => el.id === Number(data.id));

    if (selectedService !== undefined && selectedService.id !== undefined) {
      const { id, title, price } = selectedService;
      const newService: IServiceHU = {
        id: id,
        title: title,
        price: price,
        quantity: data.quantity,
      };
      addService(newService, HU);
      if (servicesState !== undefined) {
        updateServState([...servicesState, newService]);
        closeModal();
      }
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormData>({ resolver: yupResolver(schema) });

  return (
    <Container onSubmit={handleSubmit(onSubmit)}>
      <select {...register("id")}>
        {services?.map((el) => (
          <option key={el.id} value={el.id}>
            {el.title}
          </option>
        ))}
      </select>
      <p className="error">{errors.id && errors.id?.message}</p>
      <Input
        register={register}
        type="number"
        name="quantity"
        className="default"
        label="Quantidade"
      />
      <p className="error">{errors.quantity && errors.quantity?.message}</p>
      <Button type="submit" className="submit">
        Adicionar
      </Button>
    </Container>
  );
};

export default AddService;
